'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _iBem = require('../../common.blocks/i-bem/i-bem.react');

var _iBem2 = _interopRequireDefault(_iBem);

var _bFooter = (require('./../../common.blocks/footer/footer.react.js').default || require('./../../common.blocks/footer/footer.react.js')).applyDecls();

var _bFooter2 = _interopRequireDefault(_bFooter);

var _bCopyright = (require('./../../common.blocks/copyright/copyright.react.js').default || require('./../../common.blocks/copyright/copyright.react.js')).applyDecls();

var _bCopyright2 = _interopRequireDefault(_bCopyright);

var _bMFooterTI18n = function () {
    var core = require('bem-i18n');

    if (process.env.BEM_LANG ? process.env.BEM_LANG === 'ru' : process.env.REACT_APP_BEM_LANG ? process.env.REACT_APP_BEM_LANG === 'ru' : 'en' === 'ru') {
        return core().decl(require('./m-footer.i18n/ru'))('m-footer');
    }

    if (process.env.BEM_LANG ? process.env.BEM_LANG === 'en' : process.env.REACT_APP_BEM_LANG ? process.env.REACT_APP_BEM_LANG === 'en' : 'en' === 'en') {
        return core().decl(require('./m-footer.i18n/en'))('m-footer');
    }

    if (process.env.BEM_LANG ? process.env.BEM_LANG === 'be' : process.env.REACT_APP_BEM_LANG ? process.env.REACT_APP_BEM_LANG === 'be' : 'en' === 'be') {
        return core().decl(require('./m-footer.i18n/be'))('m-footer');
    }

    if (process.env.BEM_LANG ? process.env.BEM_LANG === 'id' : process.env.REACT_APP_BEM_LANG ? process.env.REACT_APP_BEM_LANG === 'id' : 'en' === 'id') {
        return core().decl(require('./m-footer.i18n/id'))('m-footer');
    }

    if (process.env.BEM_LANG ? process.env.BEM_LANG === 'kk' : process.env.REACT_APP_BEM_LANG ? process.env.REACT_APP_BEM_LANG === 'kk' : 'en' === 'kk') {
        return core().decl(require('./m-footer.i18n/kk'))('m-footer');
    }

    if (process.env.BEM_LANG ? process.env.BEM_LANG === 'tr' : process.env.REACT_APP_BEM_LANG ? process.env.REACT_APP_BEM_LANG === 'tr' : 'en' === 'tr') {
        return core().decl(require('./m-footer.i18n/tr'))('m-footer');
    }

    if (process.env.BEM_LANG ? process.env.BEM_LANG === 'tt' : process.env.REACT_APP_BEM_LANG ? process.env.REACT_APP_BEM_LANG === 'tt' : 'en' === 'tt') {
        return core().decl(require('./m-footer.i18n/tt'))('m-footer');
    }

    if (process.env.BEM_LANG ? process.env.BEM_LANG === 'uk' : process.env.REACT_APP_BEM_LANG ? process.env.REACT_APP_BEM_LANG === 'uk' : 'en' === 'uk') {
        return core().decl(require('./m-footer.i18n/uk'))('m-footer');
    }

    if (process.env.NODE_ENV === 'development') {
        process.env.BEM_LANG && console.error('No match of process.env.BEM_LANG { ' + process.env.BEM_LANG + ' } in provided langs: { ru, en, be, id, kk, tr, tt, uk }');
        process.env.REACT_APP_BEM_LANG && console.error('No match of process.env.REACT_APP_BEM_LANG { ' + process.env.REACT_APP_BEM_LANG + ' } in provided langs: { ru, en, be, id, kk, tr, tt, uk }');
    }

    return function () {};
}();

var _bMFooterTI18n2 = _interopRequireDefault(_bMFooterTI18n);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _iBem.decl)({
    block: 'm-footer',
    content: function content(_ref) {
        var region = _ref.region,
            tld = _ref.tld,
            vodstvo = _ref.vodstvo,
            mobile = _ref.mobile,
            about = _ref.about,
            email = _ref.email,
            additionalData = _ref.additionalData;

        return _react2.default.createElement(
            _bFooter2.default,
            { region: region, tld: tld },
            _react2.default.createElement(
                _bFooter2.default.Column,
                { key: 'column1' },
                this.processData()
            ),
            _react2.default.createElement(
                _bFooter2.default.Column,
                { key: 'column2', side: 'right' },
                _react2.default.createElement(
                    _iBem2.default,
                    { block: 'footer', elem: 'info' },
                    this.getInfoContent()
                ),
                _react2.default.createElement(
                    _iBem2.default,
                    { block: 'footer', elem: 'right', mobile: mobile },
                    this.getRightContent()
                )
            )
        );
    },
    processData: function processData() {
        var _props = this.props,
            email = _props.email,
            additionalData = _props.additionalData;


        email = 'mailto:' + (this.props.email || 'tools@yandex-team.ru');

        additionalData = [].concat(additionalData || []).map(function (item, i) {
            if (typeof item === 'string') {
                return _react2.default.createElement(
                    _iBem2.default,
                    { block: 'footer', key: 'addon', elem: 'addon-text' },
                    item
                );
            }

            if (item instanceof Object) {
                return _react2.default.createElement(
                    _bFooter2.default.Link,
                    { url: item.url, key: '' + i },
                    item.title
                );
            }

            return item;
        });

        return [_react2.default.createElement(
            _bFooter2.default.Link,
            { key: 'feedback', mix: { block: 'footer', elem: 'link', mods: { type: 'mailto' } }, url: email },
            (0, _bMFooterTI18n2.default)('feedback')
        )].concat(additionalData);
    },
    getInfoContent: function getInfoContent() {
        var _props2 = this.props,
            vodstvo = _props2.vodstvo,
            about = _props2.about;

        var info = [_react2.default.createElement(
            _bFooter2.default.Link,
            { key: 'confidential', url: 'https://wiki.yandex-team.ru/nda' },
            (0, _bMFooterTI18n2.default)('confidential')
        )];

        vodstvo && info.push(_react2.default.createElement(
            _bFooter2.default.Link,
            { key: 'guide', url: vodstvo },
            (0, _bMFooterTI18n2.default)('guide')
        ));

        about && info.push(_react2.default.createElement(
            _bFooter2.default.Link,
            { key: 'about', url: about },
            (0, _bMFooterTI18n2.default)('about')
        ));

        info.push(_react2.default.createElement(
            _iBem2.default,
            { block: 'footer', elem: 'info-text', key: 'info-text' },
            (0, _bMFooterTI18n2.default)('yandex_info')
        ));

        return info;
    },
    getRightContent: function getRightContent() {
        var mobile = this.props.mobile;

        var right = [_react2.default.createElement(_bCopyright2.default, { key: 'copyright', start: '2003', elemLinkMix: { block: 'footer', elem: 'link' } })];

        mobile && right.unshift(_react2.default.createElement(
            _bFooter2.default.Link,
            { key: 'mobile', url: mobile, type: 'mobile' },
            (0, _bMFooterTI18n2.default)('mobile')
        ));

        return right;
    }
}, {
    propTypes: {
        email: _propTypes2.default.string.isRequired,
        vodstvo: _propTypes2.default.string,
        about: _propTypes2.default.string,
        mobile: _propTypes2.default.string,
        additionalData: _propTypes2.default.arrayOf(_propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.shape({
            color: _propTypes2.default.string,
            fontSize: _propTypes2.default.string
        })]))
    },

    defaultProps: {
        additionalData: []
    }
});